import React from 'react';
import TextM from "@common/components/text/TextM";
import {theme} from "@common/theme/theme";
import {ListItemM} from "@common/components/list/ListItemM";
import {IconButton} from "react-native-paper";
import {FlatList, View} from "react-native";
import FilledButtonM from "@common/components/button/FilledButtonM";


const SchoolSubjectModal = ((props) => {

    const {
        options,
        onSelectSchoolSubject,
        setVisible,
        selectedSubjects = [],
        title = "Choisis la matière",
        showExitBtn = false,
        showConfirmButton = true
    } = props

    return <View style={{
        height: "100%"
    }}>
        <View>
            <TextM fontWeight="ExtraBold"
                   fontSize={20}
                   style={{
                       marginLeft: 15,
                       marginTop: 15,
                       marginBottom: 20
                   }}
                   color={theme.colors.primary}>{title}</TextM>
            <IconButton
                icon="times"
                iconColor={theme.colors.grey}
                size={22}
                style={{
                    position: "absolute",
                    right: 5,
                    top: 5
                }}
                onPress={() => {
                    setVisible(false)
                }}
            />
        </View>
        <FlatList
            data={options}
            initialScrollIndex={0}
            itemHeight={70}
            renderItem={(item) => {
                return <ListItemM isFirst={(item.index === 0)}
                                  isLast={(item.index === options?.length - 1)}
                                  onPress={() => {
                                      onSelectSchoolSubject(item?.item?.value)
                                  }}
                                  selected={selectedSubjects?.includes(item?.item?.value)}
                                  itemHeight={70}
                                  option={item.item}/>
            }}
        />
        {showConfirmButton && <FilledButtonM
            style={{
                marginTop: 10,
                marginBottom: 10,
                alignSelf: "center",
                width: "90%"
            }}
            onPress={() => setVisible(false)}
            label="Confirmer"
        />}
    </View>
})

export default SchoolSubjectModal